import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Box,
  CircularProgress,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { fetchFileSummary } from "../services/apiService";

const SummaryDialog = ({
  open,
  onClose,
  summaryData,
  onSave,
  selectedFile,
}) => {
  const [fileSummary, setFileSummary] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  // console.log("selectedFile----------", selectedFile);
  useEffect(() => {
    const getSummary = async () => {
      if (selectedFile && open) {
        setIsLoading(true);
        try {
          const response = await fetchFileSummary(selectedFile);
          // console.log("response----------",response)
          if (response.error) {
            setError(response.message);
          } else {
            setFileSummary(response?.document?.summary || "");
          }
        } catch (err) {
          setError("Failed to fetch file summary. Please try again.");
          console.error(err);
        } finally {
          setIsLoading(false);
        }
      }
    };

    getSummary();
  }, [selectedFile, open]);

  //   // Fallback to the summaryData if API call fails
  //   const filteredItems = summaryData.filter(
  //     (item) => item?.file_name === selectedFile
  //   );

  //   const summaryContent = fileSummary || filteredItems[0]?.file_summary || "";
//   console.log("summaryContent----------", fileSummary);
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="summary-dialog-title"
      aria-describedby="summary-dialog-description"
      PaperProps={{
        sx: {
          borderRadius: "12px",
          maxWidth: "1280px",
          width: "100%",
        },
      }}
    >
      <DialogTitle
        id="summary-dialog-title"
        sx={{
          fontFamily: "'Poppins', sans-serif",
          fontWeight: 600,
          color: "#1B2559",
          borderBottom: "1px solid #E2E8F0",
          padding: "16px 24px",
        }}
      >
        Summary
        <IconButton onClick={onClose} size="small" sx={{ float: "right" }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ padding: "24px", minHeight: "120px" }}>
        {isLoading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100px",
            }}
          >
            <CircularProgress sx={{ color: "#E13C25" }} />
          </Box>
        ) : error ? (
          <DialogContentText
            sx={{
              fontFamily: "'Poppins', sans-serif",
              color: "#D32F2F",
            }}
          >
            {error}
          </DialogContentText>
        ) : (
          <DialogContentText
            id="summary-dialog-description"
            sx={{
              fontFamily: "'Poppins', sans-serif",
              color: "#1B2559",
            }}
            dangerouslySetInnerHTML={{
              __html: fileSummary
                .trim()
                .replace(/[ \t]+/g, " ")
                .replace(/\n{3,}/g, "\n\n")
                .replace(/\n/g, "<br/>")
                .replace(/\*\*(.*?)\*\*/g, "<b>$1</b>")
                .replace(/#/g, "")
                .replace(/---/g, ""),
            }}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

SummaryDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  summaryData: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  onSave: PropTypes.func,
  selectedFile: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};

export default SummaryDialog;
